import React from "react";
import IPage from "../../interfaces/page"
import LoginClientComponent from "../../components/LoginClient/LoginClient.component";

const LoginClientPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <LoginClientComponent></LoginClientComponent>;
};

export default LoginClientPage;
